/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserFlagsUserControllerApplyMutationRequest,
  UserFlagsUserControllerApplyMutationResponse,
  UserFlagsUserControllerApply401,
  UserFlagsUserControllerApply404,
} from '../../types/UserFlagsUserControllerApply.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { userFlagsUserApply } from '../../methods/userFlagsUserApply.ts';
import { useMutation } from '@tanstack/react-query';

export const userFlagsUserApplyMutationKey = () => [{ url: '/api/user/user-flags/apply' }] as const;

export type UserFlagsUserApplyMutationKey = ReturnType<typeof userFlagsUserApplyMutationKey>;

/**
 * {@link /api/user/user-flags/apply}
 */
export function useUserFlagsUserApply<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UserFlagsUserControllerApplyMutationResponse,
      ResponseErrorConfig<UserFlagsUserControllerApply401 | UserFlagsUserControllerApply404>,
      { data: UserFlagsUserControllerApplyMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<UserFlagsUserControllerApplyMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? userFlagsUserApplyMutationKey();

  return useMutation<
    UserFlagsUserControllerApplyMutationResponse,
    ResponseErrorConfig<UserFlagsUserControllerApply401 | UserFlagsUserControllerApply404>,
    { data: UserFlagsUserControllerApplyMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return userFlagsUserApply(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
